document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCompare();
  initProductGallery();
  initProductVariants();
  initStickyCta();
});

function initReveal() {
  var els = document.querySelectorAll('.sh-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('sh-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-sh-delay') || '0', 10);
        setTimeout(function () { el.classList.add('sh-visible'); }, delay);
        observer.unobserve(el);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

function initCompare() {
  document.querySelectorAll('[data-sh-compare]').forEach(function (wrap) {
    var handle = wrap.querySelector('.sh-compare__handle');
    var after = wrap.querySelector('.sh-compare__after');
    if (!handle || !after) return;
    var dragging = false;

    function setPos(clientX) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - rect.left) / rect.width) * 100));
      handle.style.left = pct + '%';
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
    }

    handle.addEventListener('pointerdown', function (e) { dragging = true; handle.setPointerCapture(e.pointerId); });
    window.addEventListener('pointerup', function () { dragging = false; });
    wrap.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'mouse' || dragging) setPos(e.clientX);
    });
    wrap.addEventListener('pointerleave', function (e) {
      if (e.pointerType === 'mouse') {
        var rect = wrap.getBoundingClientRect();
        setPos(rect.left + rect.width / 2);
      }
    });
    wrap.addEventListener('click', function (e) { setPos(e.clientX); });
  });
}

function initProductGallery() {
  document.querySelectorAll('[data-sh-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-sh-gallery-main]');
    var frame = gallery.querySelector('.sh-product__gallery-main');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-sh-gallery-thumb]'));
    var prevBtn = gallery.querySelector('[data-sh-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-sh-gallery-next]');
    if (!main || !thumbs.length) return;
    var current = 0;

    var slides = main.querySelectorAll('.sh-gallery-slide');

    function render(index) {
      index = ((index % thumbs.length) + thumbs.length) % thumbs.length;
      slides.forEach(function (slide) {
        var isTarget = slide.getAttribute('data-index') === String(index);
        if (!isTarget) {
          var vid = slide.querySelector('video');
          if (vid) vid.pause();
        } else if (frame) {
          var aspect = slide.getAttribute('data-aspect');
          if (aspect) frame.style.aspectRatio = aspect;
        }
        slide.classList.toggle('is-active', isTarget);
      });
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumbs[index].classList.add('is-active');
      current = index;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { render(i); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { render(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { render(current + 1); });

    var touchStartX = null;
    main.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) {
        render(dx < 0 ? current + 1 : current - 1);
      }
      touchStartX = null;
    }, { passive: true });

    var expandBtn = gallery.querySelector('[data-sh-gallery-expand]');
    var lightbox = gallery.querySelector('[data-sh-lightbox]');
    if (expandBtn && lightbox) {
      var stage = lightbox.querySelector('[data-sh-lightbox-stage]');
      var closeBtn = lightbox.querySelector('[data-sh-lightbox-close]');
      var lbPrev = lightbox.querySelector('[data-sh-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-sh-lightbox-next]');

      function openLightbox() {
        stage.appendChild(main);
        lightbox.hidden = false;
        document.body.classList.add('sh-lightbox-open');
      }
      function closeLightbox() {
        frame.insertBefore(main, frame.firstChild);
        lightbox.hidden = true;
        document.body.classList.remove('sh-lightbox-open');
      }

      expandBtn.addEventListener('click', openLightbox);
      closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
      if (lbPrev) lbPrev.addEventListener('click', function () { render(current - 1); });
      if (lbNext) lbNext.addEventListener('click', function () { render(current + 1); });
    }
  });
}

function initProductVariants() {
  document.querySelectorAll('[data-sh-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-sh-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionInputs = form.querySelectorAll('[data-sh-option]');
    var idInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('[data-sh-add-btn]');
    var priceEl = form.querySelector('[data-sh-price]');

    function currentSelection() {
      var sel = [];
      var groups = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        groups[input.getAttribute('data-sh-option')] = input.value;
      });
      return groups;
    }

    function findVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return sel[i + ''] === val || sel[i] === val; });
      });
    }

    function updateFromSelection() {
      var sel = currentSelection();
      var match = variants.find(function (v) {
        return Object.keys(sel).every(function (idx) { return v.options[idx] === sel[idx]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl && match.price) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-label-add') || addBtn.textContent;
      }
      form.querySelectorAll('[data-sh-swatch]').forEach(function (sw) {
        var group = sw.getAttribute('data-sh-swatch-group');
        var val = sw.getAttribute('data-sh-swatch-value');
        sw.classList.toggle('is-selected', sel[group] === val);
      });
    }

    form.querySelectorAll('[data-sh-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var group = sw.getAttribute('data-sh-swatch-group');
        var val = sw.getAttribute('data-sh-swatch-value');
        var input = form.querySelector('input[data-sh-option="' + group + '"][value="' + CSS.escape(val) + '"]');
        if (input) input.checked = true;
        updateFromSelection();
      });
    });

    updateFromSelection();
  });
}

function formatMoney(cents) {
  return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
}

function initStickyCta() {
  var bar = document.querySelector('[data-sh-sticky-cta]');
  var mainBuy = document.querySelector('.sh-product__buy');
  if (!bar || !mainBuy) return;

  var stickyBtn = bar.querySelector('[data-sh-sticky-add]');
  var mainBtn = mainBuy.querySelector('[data-sh-add-btn]');
  if (stickyBtn && mainBtn) {
    stickyBtn.addEventListener('click', function () { mainBtn.click(); });
  }

  var observer = new IntersectionObserver(function (entries) {
    entries[0].target === mainBuy && bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
  }, { threshold: 0 });
  observer.observe(mainBuy);
}
